import { useIsItemPackageAvailable } from 'src/modules/checkout/composables/sales-availability/item-packages/IsItemPackageAvailable'
import { computed, toValue } from 'vue'

// Options is a hash containing fields that can be used to validate item package availability.
const DEFAULT_OPTIONS = Object.freeze({
  salesChannel: null,
  order: null
})

// itemPackages and options are optional, assuming the caller may intend to use computeAvailableItemPackages directly
export function useAvailableItemPackages (itemPackages = [], options = DEFAULT_OPTIONS) {
  const { isItemPackageAvailable } = useIsItemPackageAvailable()

  function computeAvailableItemPackages (itemPackages, { salesChannel, order } = DEFAULT_OPTIONS) {
    return _(toValue(itemPackages))
      .filter(itemPackage => isItemPackageAvailable(itemPackage, { salesChannel, order }))
      .sortBy('displayOrder')
      .value()
  }

  // We wrap itemPackages with computed to ensure reactivity
  // useAvailableItemPackages may be called with a null model, which wouldn't be reactive
  // e.g. props?.category?.itemPackages?.data before category is set
  // This would prevent availableItemPackages from reacting to changes in itemPackages
  // If itemPackages is set or already reactive, this is a safe no-op
  // This ensures useAvailableItemPackages is resilient without complicated usage requirements
  const availableItemPackages = computed(() => computeAvailableItemPackages(computed(() => itemPackages), options))

  return {
    computeAvailableItemPackages,
    availableItemPackages
  }
}
